import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { showcaseAdd, addedShowcases, removeShowcase, set_showcase_visible, get_single_showcase, get_showCaseService_data, getFreelancerShowcaseDetails, getViewShowDetails, getFreelancerShowCaseReviews } from '../../Apis';

export const ShowcaseAdd = createAsyncThunk('SubmitShowcase sdsadsadada', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await showcaseAdd(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const ShowcaseList = createAsyncThunk('ShowcaseList', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await addedShowcases(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const DeleteShowcase = createAsyncThunk('DeleteShowcase', async ({ id, token }, { rejectWithValue }) => {
    try {
        const response = await removeShowcase(id, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const MakeShowcaseVisible = createAsyncThunk('MakeShowcaseVisible', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await set_showcase_visible(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const GetEditSingleShowcase = createAsyncThunk('GetEditSingleShowcase', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await get_single_showcase(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});
export const GetShowCaseServicesData = createAsyncThunk("GetShowCaseServicesData", async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await get_showCaseService_data(formData, token)
        console.log("show rsponse for this ervice---->>>>>", response);

        return response
    } catch (error) {
        return rejectWithValue(error.response)
    }
})

export const GetFreelancerShowCaseDetails = createAsyncThunk("getfreelancerShowcases", async (query, { rejectWithValue }) => {
    try {
        const response = await getFreelancerShowcaseDetails(query)
        return response
    } catch (error) {
        return rejectWithValue(error.response);
    }
})

export const GetShowCaseReviews = createAsyncThunk("getViewShowCaseDetails", async ({ token, formData }, { rejectWithValue }) => {
    try {
        const response = await getViewShowDetails(token, formData)
        return response
    } catch (error) {
        return rejectWithValue(error.response)
    }
})

export const GetFreelancerShowCaseReviews = createAsyncThunk("getFreelancerShowCase", async ({ token, formData }, { rejectWithValue }) => {
    try {
        const response = await getFreelancerShowCaseReviews(token, formData)
        return response
    } catch (error) {
        return rejectWithValue(error.reviewData);
    }
})



const showcaseSlice = createSlice({
    name: 'showcase',
    initialState: {
        error: null,
        success: false,
        error1: null,
        success1: false,
        error2: null,
        success2: false,
        data: [],
        overviewData: {},
        descriptionData: {},
        pricingData: {},
        galleryData: {},
        activityData: {},
        reviewData: {},
        serviceData: {},
        showcaseDetails: [],
        showCaseReviews: [],
        showcaseReviews2: {}
    },
    reducers: {
        clearShowStatus: state => {
            state.success = false;
            state.error = null;
            state.success1 = false;
            state.error1 = null;
            state.success2 = false;
            state.error2 = null;
        },

        setTabDataRedux: (state, action) => {
            const { tabName, data } = action.payload;
            state[tabName] = data;
        },

        clearAllTab: state => {
            state.overviewData = {};
            state.descriptionData = {};
            state.pricingData = {};
            state.galleryData = {};
            state.activityData = {};
            state.reviewData = {};
        },

        clearShowData: state => {
            state.data = [];
        },
    },
    extraReducers: builder => {
        builder
            .addCase(ShowcaseAdd.pending, state => {
                state.error2 = null;
                state.success2 = false;
            })
            .addCase(ShowcaseAdd.fulfilled, (state, action) => {
                state.success2 = action.payload;
                state.error2 = null;
                state.overviewData = {};
                state.descriptionData = {};
                state.pricingData = {};
                state.galleryData = {};
                state.activityData = {};
                state.reviewData = {};
            })
            .addCase(ShowcaseAdd.rejected, (state, action) => {
                state.error2 = action.payload;
                state.success2 = false;
            })
            .addCase(ShowcaseList.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(ShowcaseList.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(ShowcaseList.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(DeleteShowcase.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(DeleteShowcase.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(DeleteShowcase.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
            .addCase(MakeShowcaseVisible.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(MakeShowcaseVisible.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(MakeShowcaseVisible.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
            .addCase(GetEditSingleShowcase.pending, state => {
                state.error2 = null;
                state.success2 = false;
            })
            .addCase(GetEditSingleShowcase.fulfilled, (state, action) => {
                const data = action.payload?.data?.data || {};
                state.success2 = action.payload;
                state.error2 = null;

                state.overviewData = {
                    title: data.title || '',
                    category: data.category_id || '',
                    sub_category: data.sub_cat_id || '',
                    metaCat: data.meta_cat || '',
                    meta_sub_Cat: data.meta_sub_cat || '',
                    tags: data.tags || []
                };

                state.descriptionData = {
                    description: data.description || '',
                    faqs: data.faqs || []
                };

                state.pricingData = {
                    isThreeTierChecked: data.plan_type == '3-tier' ? true : false,
                    fastDelivery: data.fast_delivery == "true" ? true : false,
                    basicExtra: data.basic_extra ? JSON.parse(data.basic_extra) : { days: '', price: '' },
                    primeExtra: data.prime_extra ? JSON.parse(data.prime_extra) : { days: '', price: '' },
                    premiumExtra: data.premium_extra ? JSON.parse(data.premium_extra) : { days: '', price: '' },

                    customAdd: data.showcase_addons,

                };

                if (data.plan_type === '3-tier' && Array.isArray(data.plans)) {
                    const [basic, prime, premium] = data.plans;

                    state.pricingData = {
                        ...state.pricingData,

                        // Basic Plan
                        mockup: basic['3Dmockup'] == "1" ? true : false,
                        amount: basic.amount,
                        basicInput: basic.basicInput,
                        concept_number: basic.concept_number,
                        currency: basic.currency,
                        delivery_days: basic.delivery_days,
                        description: basic.description,
                        favicon: basic.favicon == "1" ? true : false,
                        logo_transparency: basic.logo_transparency == "1" ? true : false,
                        printable: basic.printable == "1" ? true : false,
                        revision_number: basic.revision_number,
                        social_media_kit: basic.social_media_kit == "1" ? true : false,
                        source_files: basic.source_files == "1" ? true : false,
                        statinoery: basic.statinoery == "1" ? true : false,
                        vector: basic.vector == "1" ? true : false,

                        // Prime Plan
                        Primemockup: prime['3Dmockup'] == "1" ? true : false,
                        Primeamount: prime.amount,
                        PrimebasicInput: prime.basicInput,
                        Primeconcept_number: prime.concept_number,
                        Primecurrency: prime.currency,
                        Primedelivery_days: prime.delivery_days,
                        Primedescription: prime.description,
                        Primefavicon: prime.favicon == "1" ? true : false,
                        Primelogo_transparency: prime.logo_transparency == "1" ? true : false,
                        Primeprintable: prime.printable == "1" ? true : false,
                        Primerevision_number: prime.revision_number,
                        Primesocial_media_kit: prime.social_media_kit == "1" ? true : false,
                        Primesource_files: prime.source_files == "1" ? true : false,
                        Primestatinoery: prime.statinoery == "1" ? true : false,
                        Primevector: prime.vector == "1" ? true : false,

                        // Premium Plan
                        Premiummockup: premium['3Dmockup'] == "1" ? true : false,
                        Premiumamount: premium.amount,
                        PremiumbasicInput: premium.basicInput,
                        Premiumconcept_number: premium.concept_number,
                        Premiumcurrency: premium.currency,
                        Premiumdelivery_days: premium.delivery_days,
                        Premiumdescription: premium.description,
                        Premiumfavicon: premium.favicon == "1" ? true : false,
                        Premiumlogo_transparency: premium.logo_transparency == "1" ? true : false,
                        Premiumprintable: premium.printable == "1" ? true : false,
                        Premiumrevision_number: premium.revision_number,
                        Premiumsocial_media_kit: premium.social_media_kit == "1" ? true : false,
                        Premiumsource_files: premium.source_files == "1" ? true : false,
                        Premiumstatinoery: premium.statinoery == "1" ? true : false,
                        Premiumvector: premium.vector == "1" ? true : false,
                    };
                } else {
                    // If it's a single-tier plan
                    const plan = data.plans?.[0] || {};

                    state.pricingData = {
                        ...state.pricingData,
                        mockup: plan['3Dmockup'] == "1" ? true : false,
                        amount: plan.amount,
                        basicInput: plan.basicInput,
                        concept_number: plan.concept_number,
                        currency: plan.currency,
                        delivery_days: plan.delivery_days,
                        description: plan.description,
                        favicon: plan.favicon == "1" ? true : false,
                        logo_transparency: plan.logo_transparency == "1" ? true : false,
                        printable: plan.printable == "1" ? true : false,
                        revision_number: plan.revision_number,
                        social_media_kit: plan.social_media_kit == "1" ? true : false,
                        source_files: plan.source_files == "1" ? true : false,
                        statinoery: plan.statinoery == "1" ? true : false,
                        vector: plan.vector == "1" ? true : false
                    };
                }

                state.galleryData = {
                    images: data.images,
                    video: data.video,
                    document: data.document,
                    coverImage: data.cover_image
                }

                state.activityData = {
                    steps: data.steps,
                    questions: data.questions
                }

                state.reviewData = {
                    projectLimit: data.max_projects
                }
            })

            .addCase(GetEditSingleShowcase.rejected, (state, action) => {
                state.error2 = action.payload;
                state.success2 = false;
            })
            .addCase(GetShowCaseServicesData.pending, state => {
                state.error = null;
                state.success = false;

            })
            .addCase(GetShowCaseServicesData.fulfilled, (state, action) => {
                state.success = true
                state.serviceData = action?.payload?.data?.data || {};
                state.error = null
            })
            .addCase(GetShowCaseServicesData.rejected, (state, action) => {
                state.success = false;
                state.error = action.payload
            })
            .addCase(GetFreelancerShowCaseDetails.pending, state => {
                state.success = false;
                state.error = null;
            })
            .addCase(GetFreelancerShowCaseDetails.fulfilled, (state, action) => {
                state.success = false;
                state.error = null;
                state.showcaseDetails = action.payload.data.data

            })
            .addCase(GetFreelancerShowCaseDetails.rejected, (state, action) => {
                state.success = false;
                state.error = action.payload
            })
            .addCase(GetShowCaseReviews.pending, state => {
                state.success = false;
                state.error = null;

            })
            .addCase(GetShowCaseReviews.fulfilled, (state, action) => {
                state.success = true;
                state.error = null;
                state.data = action.payload.data;
            })
            .addCase(GetShowCaseReviews.rejected, (state, action) => {
                state.success = false;
                state.error = action.payload;

            })
            .addCase(GetFreelancerShowCaseReviews.pending, state => {
                state.success = false;
                state.error = null
            })
            .addCase(GetFreelancerShowCaseReviews.fulfilled, (state, action) => {
                state.success = true;
                state.error = null;
                state.data = action.payload.data
            })
            .addCase(GetFreelancerShowCaseReviews.rejected, (state, action) => {
                state.error = action.payload
                state.success = false
            })
    },

});
export const { clearShowStatus, setTabDataRedux, clearAllTab, clearShowData } = showcaseSlice.actions;
export default showcaseSlice.reducer;

